<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="terminal-wrapper" *ngIf="selectedTab">
    <lms-loco-update-int-usage *ngIf="selectedTab?.subTypeDetail[selectedTab.subType.toLowerCase()]?.status === 'loaded'"></lms-loco-update-int-usage>
    <lms-message-tab *ngIf="selectedTab.subTypeDetail.status?.message" [message]="selectedTab.subTypeDetail.status.message" (clearMessage)="clearErrorMessage($event)"></lms-message-tab>
    <lms-loco-context-menu [isTerminalStatusScreen]='true' [loco]='selectedLoco' *ngIf="selectedLoco" [locoId]='selectedLocoId'
        [windowCode]='windowCode' [screenName]="'terminal-status'" [locoStatusOpr]='locoStatusOpr' [addToPendingList]="lmsTerminalStatusHeaderComponent.pendingActions"></lms-loco-context-menu>
    <lms-train-context-menu [train]='selectedTrain' *ngIf="selectedTrain" [trainId]='selectedTrainId' [currentTerminal]='selectedTab.tabSearchParameter.searchText'
        [windowCode]='windowCode' [addToPendingList]="lmsTerminalStatusHeaderComponent.pendingActions" [screenName]="'terminal-status'"></lms-train-context-menu>
    <lms-terminal-status-header (lmsExceptionOutput)="lmsExceptionOutput($event)" [subTypes]='subTypes' [spinnerVal]="this.selectedTab && this.selectedTab.tabSearchParameter && this.selectedTab.tabSearchParameter.spinnerVal ? this.selectedTab.tabSearchParameter.spinnerVal: 24 "
        [noThroughTrains]="this.selectedTab && this.selectedTab.tabSearchParameter && this.selectedTab.tabSearchParameter.noThroughTrains ? this.selectedTab.tabSearchParameter.noThroughTrains: false "
        [tab]="selectedTab" [allStatusdata]="loadData"></lms-terminal-status-header>

    <div class="clear"></div>
    <div *ngIf="showHeader && selectedTab && selectedTab.subTypeDetail && (selectedTab.subTypeDetail.status?.status  == 'blank' ||  selectedTab.subTypeDetail.status?.status  == 'refresh')"
    class="page-helper-text">
        {{messages.blankSearchTerminal}}
    </div>
    <div *ngIf="showHeader && selectedTab && selectedTab.subTypeDetail && selectedTab.subTypeDetail.status?.status  == 'error'" class="page-helper-text color-red">
        {{messages.errorSearchTerminal}}
    </div>
    <div *ngIf="selectedTab && selectedTab.subTypeDetail && selectedTab.subTypeDetail.status?.status  === 'loaded'">

        <div class="in-out-bound-pending-actions">

            <lms-terminal-bound-list *ngIf="loadData" [tab]="selectedTab" [allData]="loadData" (showLocoMenu)='showLocomotiveContextMenu($event);'
                (showTrainMenu)='showTrainContextMenu($event)' [inOutBoundHeight]='inOutBoundHeight' [fullPageModeHeight]='fullPageModeHeight'
                (hideContextPanel)='hideLocoTrainContextPanel($event);' (heightCalculate)='initializePageHeight()' (drop)="drop($event)"
                (dragover)="dragover($event)"></lms-terminal-bound-list>

            <div class="pending-action-overlay pending-action-data-container" id="pending-action-data-container" *ngIf="showHeader && (selectedTab && selectedTab.subTypeDetail && selectedTab.subTypeDetail.status?.status  === 'loaded' && loadData)">
                <div class="p-overlaypanel" [style.min-height.px]='pendingActionHeight - 48' [style.max-height.px]='pendingActionHeight - 48'>
                    <lms-terminal-pending-actions [allStatusdata]="loadData" (submitPendingAction)="submitPendingActionThroughTerminalStatus($event)"
                        [lmsExceptionList]="lmsExceptionList"></lms-terminal-pending-actions>
                </div>
            </div>
            <div class="clear"></div>
        </div>

        <lms-terminal-bound-status-list *ngIf="loadData && (selectedTab.openState?.singleClick || selectedTab.openState?.collpase === null)"
            [tab]="selectedTab" [allData]="loadData" [onTermEachSlideHeight]='onTermEachSlideHeight' (onLocoSelect)='showLocomotiveContextForStatus($event);'
            (hideContextMenu)='hideLocoTrainContextPanel($event);' (heightCalculate)='initializePageHeight()'></lms-terminal-bound-status-list>

    </div>

    <p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="trainSubmitPopupDialog" (onHide)="resetPageMode()" (onShow)='setPageMode({mode: "Dialog", id: "trainSubmitPopup"});'
        [resizable]="false" class="{{errorDialog?'terminal-ui-popups error-dialog plantotrain':'terminal-ui-popups plantotrain'}}"
        [draggable]="true" header="{{popUpErrorMessage}}" [(visible)]="popupStatus.train" modal="true" closeOnEscape="true">
        <div *ngIf="popupStatus.train">
            <div class="plan-to">
                <div class="plan-to-dropdown">
                    <label><strong> Plan to Train </strong></label>
                    <input class="disabled-input" tabindex="{{tabLevel}}" type="text" spellcheck="false" contenteditable="false" disabled value="{{trainIdentifier}}"
                        style="text-transform: uppercase;">
                </div>
                <div class="terminal-handling-plan">
                    <h2>Terminal Handling Plan</h2>
                    <ul>

                        <li *ngIf="appUtilityService.isValidThpSelection(selectedTab?.tabSearchParameter?.searchText)">
                            <p-radioButton tabindex="{{tabLevel+1}}" name="radioButtonPlanLoco" value="S" label="Service Ctr / Shop" [(ngModel)]="thpPlanLoco"></p-radioButton>
                        </li>
                        <li>
                            <p-radioButton tabindex="{{tabLevel+2}}" name="radioButtonPlanLoco" value="T" label="Truck Fueling" [(ngModel)]="thpPlanLoco"></p-radioButton>
                        </li>
                        <li>
                            <p-radioButton tabindex="{{tabLevel+3}}" name="radioButtonPlanLoco" value="M" label="Main Track" [(ngModel)]="thpPlanLoco"></p-radioButton>
                        </li>
                        <li *ngIf="user && user.isUserManagerOrDirector">
                            <p-radioButton tabindex="{{tabLevel+4}}" name="radioButtonPlanLoco" value="X" label="To Storage" [(ngModel)]="thpPlanLoco"></p-radioButton>
                        </li>
                    </ul>
                    <div>

                    </div>
                </div>
                <div class="clear"></div>
            </div>
            <div class="items-to-plan">

                <div class="plan-loco-table">
                    <div class="table">
                        <div class="table-header">
                            <div class="columns-loco">Locomotive ({{intendedTrainLocoData?.locos.list.length }})</div>
                            <div class="columns-iu">Intended Usage </div>
                            <div class="columns-reason">Reason </div>
                            <div class="columns-notes"> </div>
                        </div>
                        <div class="table-body">
                            <div class="table-row" *ngFor="let loco of intendedTrainLocoData?.locos.list; let i = index">
                                <lms-intended-usage [tabLevel]='tabLevel + 10 + (i*5)' [locoData]='loco' [indexPosition]='i'></lms-intended-usage>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="dialog-buttons">
                <span class="pull-left">
				<button class="p-button-secondary" tabindex="{{tabLevel+101}}" (click)="hideDialog()">Cancel</button>
			</span>
                <span class="pull-right">
				<button class="p-button-secondary" tabindex="{{tabLevel+102}}" (click)="addToPending(intendedTrainLocoData,'Train','',trainIdentifier)">Add to Pending</button>
			<button class="p-button-primary" id="trainSubmitPopup" tabindex="{{tabLevel+103}}" (click)="planLocomotiveSubmit('Train')">Submit</button>
			</span>
            </div>
        </div>
    </p-dialog>

    <p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="planSubmitPopupDialog" (onHide)="resetPageMode()" (onShow)='planDialogPageMode({mode: "Dialog", id: "planSubmitPopup"}); setFocusToGivenElement("terminalStatusPlanTrnInput", "5"); fillTerminalValue();'
        [(visible)]="popupStatus.plan" [resizable]="false" [draggable]="true" class="{{errorDialog?'terminal-ui-popups error-dialog':'terminal-ui-popups'}}"
        [ngClass]="{'error-dialog':errorDialog}" header="{{popUpErrorMessage}}" modal="true" closeOnEscape="true">
        <div *ngIf="popupStatus.plan">
            <div class="plan-to">

                <div class="plan-to-dropdown">
                    <label>Plan to </label>
                    <p-dropdown class="pull-left" tabindex="{{tabLevel}}" [options]="planOption" (onChange)='changePlanOptions()' [(ngModel)]='selectedPlan' panelStyleClass="dialog-dropdown"
                        ></p-dropdown>
                </div>

                <div class="plan-to-input" *ngIf="selectedPlan === 'Train'">
                    <label>Train</label>
                    <span class="select-train-terminal">
				<input id="terminalStatusPlanTrnInput" type="text" tabindex="{{tabLevel+1}}" placeholder="Train ID" spellcheck="false"  class="{{isAddTrainError ? 'p-inputfield train-placeholder p-inputfield-error' : 'p-inputfield train-placeholder'}}"  name="planTrainId" [(ngModel)]="planTrainId" required minlength="6" maxlength="6">
				<div class="color-red" *ngIf='isAddTrainError'>{{configData.messages.planInvalidTrainId}}</div>
				</span>


                </div>

                <div class="plan-to-input" *ngIf="selectedPlan !== 'Train'">
                    <label>Terminal</label>
                    <span class="select-train-terminal">
					<lms-autocomplete spellcheck="false"  tabindex="{{tabLevel+2}}" styleclass="p-autocomplete" [inputId]='"terminalStatusPlanCommInput"' [(ngModel)]="searchPlanTextTerminal" [ngClass]="'terminal-autocomplete'"
						placeholder="Mnemonic" [suggestions]="filteredResults" (completeMethod)="autoCompleteForTerminal($event)" [minLength]="2" (onSelect)="selectValueFromAutoComplete(searchPlanTextTerminal,'terminalPlanSuggestSearch')"
                        [maxlength]="6" (keydown.space)='$event.stopPropagation();' (keydown.spacebar)='$event.stopPropagation();' (keyup.space)='$event.stopPropagation();' (keyup.spacebar)='$event.stopPropagation();'
                        inputStyleClass="{{searchPlanTextTerminalError ? 'p-inputfield-error' : ''}}" ></lms-autocomplete>	
                        <font class="update-terminal-text" *ngIf="selectedPlan ==='Terminal'"> Enter terminal.  Press TAB to evaluate servicing capability.</font>
<div class="color-red" *ngIf='searchPlanTextTerminalError'> {{configData.messages.planInvalidTerminal}} </div>		
				</span>
                </div>

                <div class="plan-to-input frr-road" [hidden]="selectedPlan !=='Foreign Railroad'">
                    <label>Road</label>
                    <span class="select-train-terminal">
				<p-dropdown [filter]="true" [options]="selectedRoadValues" tabindex="{{tabLevel+3}}" [disabled]="!selectedTerminalRoad" styleClass="{{selectedTerminalRoadError ? 'p-inputfield-error pull-left p-dropdown' : 'pull-left p-dropdown'}}" ngModel name='roadValue' [(ngModel)]='selectedTerminalRoad' panelStyleClass="dialog-dropdown" >
					<ng-template let-roadValue pTemplate="roadValue">
						<div class="p-helper-clearfix">
						<div> {{roadValue.label}} </div>
						</div>
				</ng-template>
				</p-dropdown>
				<div class="color-red" *ngIf='selectedTerminalRoadError'> {{configData.messages.planInvalidRoad}} </div>
				</span>

                </div>
                <div class="terminal-handling-plan" [hidden]="selectedPlan === 'Foreign Railroad'">
                    <h2>Terminal Handling Plan</h2>
                    <ul>
                        <li *ngIf="!isValidThpSelection">
                            <p-radioButton tabindex="{{tabLevel+4}}" name="radioButtonPlanLoco" value="S" label="Service Ctr / Shop" [(ngModel)]="thpPlanLoco"></p-radioButton>
                        </li>
                        <li>
                            <p-radioButton tabindex="{{tabLevel+5}}" name="radioButtonPlanLoco" value="T" label="Truck Fueling" [(ngModel)]="thpPlanLoco"></p-radioButton>
                        </li>
                        <li>
                            <p-radioButton tabindex="{{tabLevel+6}}" name="radioButtonPlanLoco" value="M" label="Main Track" [(ngModel)]="thpPlanLoco"></p-radioButton>
                        </li>
                        <li *ngIf="user && user.isUserManagerOrDirector">
                            <p-radioButton tabindex="{{tabLevel+7}}" name="radioButtonPlanLoco" value="X" label="To Storage" [(ngModel)]="thpPlanLoco"></p-radioButton>
                        </li>


                    </ul>
                    <div>

                    </div>
                </div>
                <div class="clear"></div>
            </div>

            <div class="items-to-plan" *ngIf="selectedPlan !=='Train'">
                <h2>Locomotives ({{intendedTrainLocoData?.locos.list.length}})</h2>
                <ul>
                    <li *ngFor="let locoDetails of intendedTrainLocoData.locos.list">
                        {{ locoDetails.locomotiveIdentifier }}
                    </li>
                </ul>
            </div>
            <div class="items-to-plan" *ngIf="selectedPlan ==='Train'">

                <div class="plan-loco-table">
                    <div class="table">
                        <div class="table-header">
                            <div class="columns-loco">Locomotive ({{intendedTrainLocoData?.locos.list.length }})</div>
                            <div class="columns-iu">Intended Usage </div>
                            <div class="columns-reason">Reason </div>
                            <div class="columns-notes"> </div>
                        </div>
                        <div class="table-body">
                            <div class="table-row" *ngFor="let loco of intendedTrainLocoData?.locos.list; let i = index">
                                <lms-intended-usage [tabLevel]='tabLevel + 10 + (i*5)' [locoData]='loco' [indexPosition]='i'></lms-intended-usage>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="dialog-buttons">
                <span class="pull-left">
				<button class="p-button-secondary" tabindex="{{tabLevel+101}}" (click)="hideDialog()">Cancel</button>
			</span>
                <span class="pull-right">
				<button class="p-button-secondary" tabindex="{{tabLevel+102}}" (click)="addToPending(intendedTrainLocoData,selectedPlan)">Add to Pending</button>
			<button class="p-button-primary" tabindex="{{tabLevel+103}}" id="planSubmitPopup" (click)="planLocomotiveSubmit()">Submit</button>
			</span>
            </div>
        </div>
    </p-dialog>

    <p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="terminalSubmitPopupDialog" [resizable]="false" (onShow)='setPageMode({mode: "Dialog", id: "terminalSubmitPopup"});'
        (onHide)="resetPageMode()" [draggable]="true" class="{{errorDialog?'terminal-ui-popups error-dialog':'terminal-ui-popups'}}"
        header="{{popUpErrorMessage}}" [(visible)]="popupStatus.terminal" modal="true" closeOnEscape="true">
        <div *ngIf="popupStatus.terminal">
            <div class="plan-to">
                <div class="plan-to-input">
                    <label>Plan to Terminal</label>
                    <span>
				<input tabindex="{{tabLevel}}" class="train-placeholder" spellcheck="false" type="text" contenteditable="false" disabled value="{{selectedTab.tabSearchParameter?.searchText}}">
				</span>
                </div>

                <div class="terminal-handling-plan">
                    <h2>Terminal Handling Plan</h2>
                    <ul>
                        <li *ngIf="appUtilityService.isValidThpSelection(selectedTab?.tabSearchParameter?.searchText)">
                            <p-radioButton tabindex="{{tabLevel+1}}" name="radioButtonPlanLoco" value="S" label="Service Ctr / Shop" [(ngModel)]="thpPlanLoco"></p-radioButton>
                        </li>
                        <li>
                            <p-radioButton tabindex="{{tabLevel+2}}" name="radioButtonPlanLoco" value="T" label="Truck Fueling" [(ngModel)]="thpPlanLoco"></p-radioButton>
                        </li>
                        <li>
                            <p-radioButton tabindex="{{tabLevel+3}}" name="radioButtonPlanLoco" value="M" label="Main Track" [(ngModel)]="thpPlanLoco"></p-radioButton>
                        </li>
                        <li *ngIf="user && user.isUserManagerOrDirector">
                            <p-radioButton tabindex="{{tabLevel+4}}" name="radioButtonPlanLoco" value="X" label="To Storage" [(ngModel)]="thpPlanLoco"></p-radioButton>
                        </li>
                    </ul>
                    <div>

                    </div>
                </div>
                <div class="clear"></div>
            </div>

            <div class="items-to-plan">
                <h2>Locomotives ({{dragLocosData.length}})</h2>
                <ul>
                    <li *ngFor="let locoDetails of dragLocosData">
                        {{locoDetails.locomotiveIdentifier}}
                    </li>
                </ul>
            </div>

            <div class="dialog-buttons">
                <span class="pull-left">
				<button class="p-button-secondary" tabindex ="{{tabLevel+5}}" (click)="hideDialog()">Cancel</button>
			</span>
                <span class="pull-right">
				<button class="p-button-secondary" tabindex ="{{tabLevel+6}}" (click)="addToPending(trainLocoData,'Terminal',selectedTab.tabSearchParameter?.searchText)">Add to Pending</button>
			<button class="p-button-primary" id="terminalSubmitPopup" tabindex ="{{tabLevel+7}}" (click)="planLocomotiveSubmit('Terminal')">Submit</button>
			</span>
            </div>
        </div>
    </p-dialog>

    <p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="resequenceSubmitPopupDialog" [resizable]="false" (onShow)='setPageMode({mode: "Dialog", id: "resequenceSubmitPopup"});'
        (onHide)="cancelResequence(resequenceTrainData?.trainIdentifier);resetPageMode();" [draggable]="true" class="{{errorDialog?'error-dialog terminal-ui-popups':'terminal-ui-popups'}}"
        header="{{popUpErrorMessage}}" [(visible)]="popupStatus.resequence" modal="true" closeOnEscape="true">
        <div *ngIf="popupStatus.resequence">
            <div class="dialog-container">
                <div class="items-to-plan resequence-dialog">
                    <ul>
                        <li *ngFor="let locoDetails of dragLocosData">
                            {{removeSpaceLocomotiveId(locoDetails.locomotiveIdentifier)}}
                        </li>
                    </ul>
                </div>
                <p class="text-center clear generic-spacing">On</p>
                <ul class="text-center clear">
                    <li>
                        <span class="loco-tag float-none">Train {{resequenceTrainData.trainIdentifier}}</span>
                    </li>
                </ul>
            </div>

            <div class="dialog-buttons">
                <span class="pull-left">
             	<button tabindex="{{tabLevel}}" class="p-button-secondary" (click)="cancelResequence(resequenceTrainData.trainIdentifier)">Cancel</button>
			</span>
                <span class="pull-right">
            	<button tabindex="{{tabLevel + 1}}" class="p-button-secondary" (click)="addToPending(trainLocoData,'resequence')">Add to Pending</button>
           <button tabindex="{{tabLevel +2}}" class="p-button-primary" id="resequenceSubmitPopup" (click)="resequenceLocmotiveSubmit(resequenceTrainData.trainIdentifier)">Submit</button>
			</span>
            </div>
        </div>
    </p-dialog>

    <p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="completeTrainSubmitPopupDialog" [resizable]="false" (onHide)="resetPageMode();hideDialog()" [draggable]="true"
        class="{{errorDialog?'terminal-ui-popups complete-train-dialog error-dialog':'terminal-ui-popups complete-train-dialog'}}"
        header="{{popUpErrorMessage}}" [(visible)]="popupStatus.completeTrain" modal="true" closeOnEscape="true" (onShow)='setPageMode({mode: "Dialog", id: "completeTrainSubmitPopup"});'>

        <div *ngIf="popupStatus.completeTrain">
            <div class="items-to-plan">
                <p *ngIf="!trainLocoData?.locos.list.length" class="complete-train-msg">Are you sure you want to complete the selected Train(s)?</p>
                <p *ngIf="trainLocoData?.locos.list.length" class="complete-train-msg">Selected Trains can’t be completed if locomotives are assigned.<br/> Remove Locomotives to Cancel?</p>
                <ul class="cancel-trains-container">
                    <li *ngFor="let train of trainLocoData?.trains.list">
                        <span class="loco-tag">{{train.trainIdentifier}}</span>
                    </li>
                </ul>
            </div>

            <div class="dialog-buttons">
                <span class="pull-left" *ngIf="!trainLocoData?.locos.list.length">
				<button id='completeTrainTerminalId'  tabindex="{{tabLevel}}" class="p-button-secondary" (click)="hideDialog()">Cancel</button>
			</span>
                <span class="pull-right" *ngIf="!trainLocoData?.locos.list.length">
			<button disabled="{{disableCancelComplete?'disable':''}}" class="{{disableCancelComplete?'p-button-disabled':'p-button-secondary'}}" (click)="addToPending(trainLocoData,'complete')"  tabindex="{{tabLevel + 1}}">Add to Pending</button>
			<button disabled="{{disableCancelComplete?'disable':''}}" class="{{disableCancelComplete?'p-button-disabled':'p-button-primary'}}" id="completeTrainSubmitPopup"  (click)="cancelCompleteTrainOperation(trainLocoData,'completeTrain')" tabindex="{{ tabLevel + 2 }}">Submit</button>
			</span>
                <span class="pull-right" tabindex="{{tabLevel}}" *ngIf="trainLocoData?.locos.list.length">
			<button class="p-button-secondary" (click)="hideDialog()">Ok</button>
			</span>

            </div>
        </div>
    </p-dialog>

    <p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="cancelTrainSubmitPopupDialog" [resizable]="false" (onHide)="resetPageMode();hideDialog()" [draggable]="true"
        class="{{errorDialog?'error-dialog terminal-ui-popups complete-train-dialog':'terminal-ui-popups complete-train-dialog'}}"
        header="{{popUpErrorMessage}}" [(visible)]="popupStatus.cancelTrain" modal="true" closeOnEscape="true" (onShow)='setPageMode({mode: "Dialog", id: "cancelTrainSubmitPopup"});'>
        <div *ngIf="popupStatus.cancelTrain">
            <div class="items-to-plan">
                <p *ngIf="!trainLocoData?.locos.list.length" class="complete-train-msg">Are you sure you want to cancel the selected Train(s)?</p>
                <p *ngIf="trainLocoData?.locos.list.length" class="complete-train-msg">Selected Trains can’t be cancelled if locomotives are assigned.<br/> Remove Locomotives to Cancel?</p>
                <ul class="cancel-trains-container">
                    <li *ngFor="let train of trainLocoData?.trains.list">
                        <span class="loco-tag">{{train.trainIdentifier}}</span>
                    </li>

                </ul>
            </div>

            <div class="dialog-buttons">
                <span class="pull-left" *ngIf="!trainLocoData?.locos.list.length">
				<button id='cancelTrainTerminalId' class="p-button-secondary" tabindex="{{tabLevel}}" (click)="hideDialog()">Cancel</button>
			</span>
                <span class="pull-right" *ngIf="!trainLocoData?.locos.list.length">
				<button disabled="{{disableCancelComplete?'disable':''}}" class="{{disableCancelComplete?'p-button-disabled':'p-button-secondary'}}"  tabindex="{{tabLevel + 1}}" (click)="addToPending(trainLocoData,'cancel')">Add to Pending</button>
				<button disabled="{{disableCancelComplete?'disable':''}}" class="{{disableCancelComplete?'p-button-disabled':'p-button-primary'}}" id="cancelTrainSubmitPopup" (click)="cancelCompleteTrainOperation(trainLocoData,'cancelTrain')" tabindex="{{tabLevel + 2}}">Submit</button>
			</span>
                <span class="pull-right" *ngIf="trainLocoData?.locos.list.length">
			<button class="p-button-secondary"  tabindex="{{tabLevel}}"(click)="hideDialog()">Ok</button>
			</span>

            </div>
        </div>
    </p-dialog>



    <p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="mixSubmitPopupDialog" [resizable]="false" (onShow)='setPageMode({mode: "Dialog", id: "mixSubmitPopup"});' (onHide)="resetPageMode()"
        [draggable]="true" class="terminal-ui-popups complete-train-dialog error-dialog" header="{{mixErrorTitle}}" [(visible)]="popupStatus.mix"
        modal="true" closeOnEscape="true">

        <div *ngIf="popupStatus.mix">
            <div class="items-to-plan">
                <p class="complete-train-msg">{{mixErrorMessage}}</p>
            </div>

            <div class="dialog-buttons">
                <span class="pull-right">
												<button tabindex="{{tabLevel}}" class="p-button-primary" id="mixSubmitPopup" (click)="hideDialog()">OK</button>
											</span>
            </div>
        </div>
    </p-dialog>

    <!-- Start Rule Exception Popup -->
    <p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="ruleExceptionLocoDataDialog" [resizable]="false" [draggable]="true" (onShow)='setPageMode({mode: "Dialog", id: "ruleExceptionLocoData"});'
        (onHide)="resetPageMode(); cancelRuleException(popupType);" class="terminal-ui-popups rule-exceptions" header="Rules Warning"
        [(visible)]="ruleException" modal="true" closeOnEscape="true">
        <div class="bre-dialog-header">
            <div class="plan-to-dropdown">
                <label class="pull-left block-32">Plan to Train</label>
                <span class="loco-tag">{{planTrainId ? planTrainId.toUpperCase() : '-'}}</span>
            </div>

        </div>
        <div class="exception-reason">
            <span class="exception-icon"></span>
            <div class="exception-details">
                <span class="color-red">Exception with {{(lmsExceptionList && lmsExceptionList.length > 1) ? lmsExceptionList.length : '' }} Planned {{(lmsExceptionList
			&& lmsExceptionList.length > 1) ? 'Locomotives' : 'Locomotive' }}</span>
                <p class="info-text">To <span>Override Rule</span>,{{(lmsExceptionList && lmsExceptionList.length > 1) ? ' Select Loco and hit
                    submit. Unselected Loco will be auto cancelled.': ' add Reason and hit submit.' }}</p>
            </div>

        </div>
        <div class="exceptions-tbl-head">

            <span class="locomotive-head">LOCOMOTIVE</span>
            <span class="exception-intended-usage-head">INTENDED USAGE INFO</span>
            <span class="exception-info-head">WARNING</span>

        </div>

        <div class="exception-dialog">

            <div class="exception-list">
                <div class="exception-rows" *ngFor='let lException of lmsExceptionList; let i = index'>
                    <lms-bre-exception [lmsException]='lException' (checkCheckedLoco)="checkCheckedLoco($event)"></lms-bre-exception>
                </div>
            </div>
        </div>
        <div class="dialog-buttons">
            <span class="pull-right">
								<button type="button" tabindex="{{tabLevel}}" class="p-button-secondary" (click)="cancelRuleException(popupType)">Cancel</button>
								<button type="button" tabindex="{{tabLevel + 1}}" id='ruleExceptionLocoData' [ngClass]="isRuleExceptionSubmitEnabled? 'p-button-primary' : 'p-button-secondary p-button-disabled'" disabled="{{isRuleExceptionSubmitEnabled? '' : 'disabled'}}" (click)="ruleExceptionSubmit(popupType)">Submit</button>
							</span>
        </div>
    </p-dialog>
    <!-- END Rule Exception Popup -->
</div>